import React, { useEffect, useState, useContext } from 'react';
import ModuleTitle from '../../../module-title';
import './index.less';
import IconTip from '@/components/icon-tip';
import apis from '@/pages/mvp-panel/participant-data/apis';
import ProviderUserTypeInfo from '../../../../provider-userType-info';
import { formatPrice } from '@/common/utils';
import { message } from '@drip/drip-design';

const GoodsScale = (props) => {
  const [data, setData] = useState();
  const value = useContext(ProviderUserTypeInfo);
  const [conditions, setConditions] = useState({
    // itemFirstCateCd: '全部',
    // itemSecondCateCd: '全部',
    itemThirdCateCd: ['全部'],
    brandCode: '全部',
    shopId: '全部',
  });

  //吸顶筛选结果更新
  useEffect(() => {
    setConditions((conditions) => Object.assign({}, conditions, { ...props.param }, { ...value }));
  }, [props.param, value]);
  useEffect(() => {
    if (!conditions.userType || !conditions.planCode) return;
    apis.queryIndexOngoingInfo(conditions).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setData(data);
      } else {
        message.error(msg);
      }
    });
  }, [conditions]);
  return (
    <div className="participant-goods-scale-bg">
      {data && data.applySkuNums && data.putonSkuNumsTotal && (
        <ModuleTitle title="商品规模">
          <div className="goods-scale-sku-info">
            <div style={{ flex: '1' }}>
              <div className="goods-scale-skuinfo-title">
                报名SKU数
                <IconTip
                  title="参与者权限下的sku在该活动下，从活动开始时间到活动结束时间段内累计去重报名sku数"
                  type="question"
                  size="small"
                />
              </div>
              <div className="goods-scale-skuinfo-value">{formatPrice(data.applySkuNums) || '-'}</div>
            </div>
            <div style={{ flex: '1' }}>
              <div className="goods-scale-skuinfo-title">
                上场SKU数
                <IconTip
                  title="参与者权限下的sku在该活动下，从活动开始时间到活动结束时间内被选入进商品组并挂靠至会场楼层的累计去重上场sku数（不包含从上游接口实时计算未在投放平台落库的sku，上游包含推荐，全渠道，秒杀等）"
                  type="question"
                  size="small"
                />
              </div>
              <div className="goods-scale-skuinfo-value">{formatPrice(data.putonSkuNumsTotal) || '-'}</div>
            </div>
          </div>
        </ModuleTitle>
      )}
    </div>
  );
};
export default GoodsScale;
